export default "__VITE_ASSET__B6W5iGWj__"